var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-media-object',[_c('template',{slot:"left"},[(_vm.hasNetwork(_vm.task))?_c('network-icon',{attrs:{"network":_vm.task.network.slug}}):_vm._e()],1),_vm._v(" "),[_c('g-typography',{attrs:{"value":_vm.getTaskTitle(_vm.task)}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }